import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'info-capsule',
  templateUrl: './capsule.component.html',
  styleUrls: ['./capsule.component.scss'],
})
export class CapsuleComponent {

  @Input() title: undefined | string;
  @Input() color: string = "primary";
  @Input() fontColor: string = "";
  @Input() buttonLabel: undefined | string;
  @Input() iconCharacter: undefined | string;
  @Input() icon: undefined | string;
  @Input() iconLayout: 'badge' | 'default' = 'default';

  @Output() onClick : EventEmitter<any> = new EventEmitter();

  handleClick(){
    this.onClick.emit();
  }

}
